module.exports = __webpack_public_path__ + "img/step3_green.87583938.png";